import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { SttSeeButton, SttHidden, SttTranslateHook, SttCtrlP, SttCircularProgress } from '@stt-componentes/core';
import {
	SttTable,
	SttTableHead,
	SttTableBody,
	SttTableRow,
	SttTableCell,
	SttTableSortLabel,
	SttTablePagination,
	SttContainerTitle,
	SttTableCard
} from '@stt-componentes/core-v2';
import Form from './form';
import Detalhes from './detalhes';
import { batch } from '@preact/signals-react';
import { useSignal, useSignals } from '@preact/signals-react/runtime';
import { NotificationManager } from 'react-notifications';

const useStyles = makeStyles((theme) => ({
	tableWrapper: {
		marginTop: theme.spacing(3)
	}
}));

const ORDENACAO = {
	DIRECAO: {
		ASC: 'asc',
		DESC: 'desc'
	},
	CAMPOS: {
		DATA: 'data',
		SOLICITANTE: 'solicitante',
		PACIENTE: 'nome_paciente',
		CIDADE_PROCEDENCIA: 'nome_cidade'
	}
};

const SolicitacoesEmAberto = () => {
	const { strings } = useContext(SttTranslateHook.I18nContext);
	const classes = useStyles();
	useSignals();

	const solicitacoes = useSignal([]);
	const buscaEmAndamento = useSignal(false);
	const page = useSignal(global.gConfig.pagination.start);
	const count = useSignal(global.gConfig.pagination.count);
	const totalRegistros = useSignal(0);
	const order = useSignal(ORDENACAO.DIRECAO.ASC);
	const orderBy = useSignal(null);
	const buscar = useSignal(true);
	const idSolicitacaoSelecionada = useSignal(null);

	const resetPageOrder = () => {
		batch(() => {
			page.value = global.gConfig.pagination.start;
			count.value = global.gConfig.pagination.count;
			order.value = ORDENACAO.DIRECAO.DESC;
			orderBy.value = ORDENACAO.CAMPOS.DATA;
		});
	};

	const handleClickSort = (campo) => {
		const isAsc = orderBy.value === campo && order.value === ORDENACAO.DIRECAO.ASC;
		const newOrder = isAsc ? ORDENACAO.DIRECAO.DESC : ORDENACAO.DIRECAO.ASC;
		batch(() => {
			order.value = newOrder;
			orderBy.value = campo;
			buscar.value = true;
		});
	};

	const handleChangePage = (event, newPage) => {
		batch(() => {
			page.value = newPage;
			buscar.value = true;
		});
	};

	const handleChangeRowsPerPage = (event) => {
		batch(() => {
			count.value = event.target.value;
			page.value = global.gConfig.pagination.start;
			buscar.value = true;
		});
	};

	const callbackBusca = (dados) => {
		batch(() => {
			if (dados) {
				totalRegistros.value = parseInt(dados.totalRegistros);
				solicitacoes.value = dados.itens;
			} else {
				totalRegistros.value = 0;
				solicitacoes.value = [];
			}
			buscar.value = false;
		});
	};

	const handleClickVoltar = (atualizarBusca) => {
		batch(() => {
			idSolicitacaoSelecionada.value = null;
			buscar.value = !!atualizarBusca;
		});
	};

	if (idSolicitacaoSelecionada.value) {
		return (
			<Detalhes
				id={idSolicitacaoSelecionada.value}
				voltar={handleClickVoltar}
			/>
		);
	}

	const callbackImpedirImpressao = () => {
		NotificationManager.error(strings.impressaoDesabilitada);
	};

	return (
		<>
			{
				idSolicitacaoSelecionada.value === null
					?
					<>
						<SttContainerTitle titulo={strings.pesquisaSolicitacoesExame} />
						<Form
							strings={strings}
							callbackBusca={callbackBusca}
							buscaEmAndamento={buscaEmAndamento}
							page={page}
							count={count}
							orderBy={orderBy}
							order={order}
							buscar={buscar}
							resetPageOrder={resetPageOrder}
						/>
						<div className={classes.tableWrapper}>
							<SttHidden smDown>
								<SttTable>
									<SttTableHead>
										<SttTableRow>
											<SttTableCell
												width="10%"
												sortDirection={orderBy.value === ORDENACAO.CAMPOS.DATA ? order.value : false}
											>
												<SttTableSortLabel
													active={orderBy.value === ORDENACAO.CAMPOS.DATA}
													direction={orderBy.value === ORDENACAO.CAMPOS.DATA ? order.value : ORDENACAO.DIRECAO.ASC}
													onClick={() => handleClickSort(ORDENACAO.CAMPOS.DATA)}
												>
													{strings.dataSolicitacao}
												</SttTableSortLabel>
											</SttTableCell>
											<SttTableCell
												width="25%"
												sortDirection={orderBy.value === ORDENACAO.CAMPOS.SOLICITANTE ? order.value : false}
											>
												<SttTableSortLabel
													active={orderBy.value === ORDENACAO.CAMPOS.SOLICITANTE}
													direction={orderBy.value === ORDENACAO.CAMPOS.SOLICITANTE ? order.value : ORDENACAO.DIRECAO.ASC}
													onClick={() => handleClickSort(ORDENACAO.CAMPOS.SOLICITANTE)}
												>
													{strings.solicitante}
												</SttTableSortLabel>
											</SttTableCell>
											<SttTableCell
												width="25%"
												sortDirection={orderBy.value === ORDENACAO.CAMPOS.PACIENTE ? order.value : false}
											>
												<SttTableSortLabel
													active={orderBy.value === ORDENACAO.CAMPOS.PACIENTE}
													direction={orderBy.value === ORDENACAO.CAMPOS.PACIENTE ? order.value : ORDENACAO.DIRECAO.ASC}
													onClick={() => handleClickSort(ORDENACAO.CAMPOS.PACIENTE)}
												>
													{strings.paciente}
												</SttTableSortLabel>
											</SttTableCell>
											<SttTableCell
												width="15%"
												sortDirection={orderBy.value === ORDENACAO.CAMPOS.CIDADE_PROCEDENCIA ? order.value : false}
											>
												<SttTableSortLabel
													active={orderBy.value === ORDENACAO.CAMPOS.CIDADE_PROCEDENCIA}
													direction={orderBy.value === ORDENACAO.CAMPOS.CIDADE_PROCEDENCIA ? order.value : ORDENACAO.DIRECAO.ASC}
													onClick={() => handleClickSort(ORDENACAO.CAMPOS.CIDADE_PROCEDENCIA)}
												>
													{`${strings.municipio}/${strings.uf}`}
												</SttTableSortLabel>
											</SttTableCell>
											<SttTableCell width="5%">{strings.visualizar}</SttTableCell>
										</SttTableRow>
									</SttTableHead>
									<SttTableBody>
										{buscaEmAndamento.value ? (
											<SttTableRow key="carregando-dados">
												<SttTableCell
													colSpan={6}
													align="center"
												>
													<SttCircularProgress />
												</SttTableCell>
											</SttTableRow>
										) : solicitacoes.value.length === 0 ? (
											<SttTableRow key="nenhum-registro">
												<SttTableCell
													colSpan={6}
													align="center"
												>
													{strings.nenhumRegistroEncontrado}
												</SttTableCell>
											</SttTableRow>
										) : (
											solicitacoes.value.map((row, index) => (
												<SttTableRow key={row.id}>
													<SttTableCell>{`${row.data_formatada} ${global.gConfig.sufixo_data_hora}`}</SttTableCell>
													<SttTableCell>{row.solicitante}</SttTableCell>
													<SttTableCell>{row.nome_paciente}</SttTableCell>
													<SttTableCell>{row.nome_cidade_estado}</SttTableCell>
													<SttTableCell align="center">
														<SttSeeButton
															id={`btn-ver-solicitacao-${index}`}
															onClick={() => {
																idSolicitacaoSelecionada.value = row.id;
															}}
														/>
													</SttTableCell>
												</SttTableRow>
											))
										)}
									</SttTableBody>
								</SttTable>
							</SttHidden>
							<SttHidden mdUp>
								{buscaEmAndamento | (solicitacoes.value.length === 0) ? (
									<SttTableCard
										carregando={buscaEmAndamento.value}
										nenhumRegistroEncontrado={solicitacoes.value.length === 0 ? strings.nenhumRegistroEncontrado : null}
									/>
								) : (
									solicitacoes.value.map((row, index) => (
										<SttTableCard
											key={index}
											titulo={row.nome_paciente}
											acao={
												<SttSeeButton
													onClick={() => {
														idSolicitacaoSelecionada.value = row.id;
													}}
												/>
											}
											conteudo={[
												[
													{ titulo: strings.data, valor: `${row.data_formatada} ${global.gConfig.sufixo_data_hora}`, xs: 6 },
													{
														titulo: `${strings.municipio}/${strings.uf}`,
														valor: row.nome_cidade_estado,
														xs: 6
													}
												],
												[{ titulo: strings.solicitante, valor: row.solicitante }]
											]}
										/>
									))
								)}
							</SttHidden>
						</div>
						{solicitacoes.value.length > 0 ? (
							<SttTablePagination
								rowsPerPageOptions={[10, 20, 40]}
								component="div"
								count={totalRegistros.value}
								rowsPerPage={count.value}
								page={page.value}
								onPageChange={handleChangePage}
								onRowsPerPageChange={handleChangeRowsPerPage}
								labelRowsPerPage={strings.linhasPorPagina}
								labelDisplayedRows={(params) => `${params.from}-${params.to} ${strings.de} ${params.count}`}
							/>
						) : null}
						<SttCtrlP callback={callbackImpedirImpressao} />
					</>
					:
					<Detalhes
						id={idSolicitacaoSelecionada.value}
						voltar={handleClickVoltar}
					/>
			}
		</>
	);
};

export default SolicitacoesEmAberto;
